import useEventListener from './use-event-listener.js';
import useTimeout from './use-timeout.js';
function useLongPress(elementRef, handler, { duration = 400 } = {}) {
    const [cancel, create] = useTimeout(handler, duration, {
        scheduled: false,
    });
    useEventListener('touchstart', create, elementRef);
    useEventListener('touchend', cancel, elementRef);
    useEventListener('touchmove', cancel, elementRef);
    useEventListener('touchcancel', cancel, elementRef);
}
export default useLongPress;
